<template>
    <div>
        <el-form-item label="样式：" label-width="110px">
            <el-radio-group v-model="config['style_type']" @change="change" class="radio-group">
                <el-col v-for="(item,index) in radioList" :key="index" class="radio-item">
                    <el-radio :label="item.value"><img :src="item.url" alt="" class="radio-img"></el-radio>
                    <span v-if="item.text" :class="index === currentRadioIndex - 1 ? 'selected' : ''">{{item.text}}</span>
                </el-col>
            </el-radio-group>
        </el-form-item>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <draggable v-model="config[field.key]">
                <el-row class="image-item" v-for="(item,index) in config[field.key]" :key="index" type="flex">
                    <el-col class="col-left">
                        <choose-photo
                          :config="config"
                          :field="field"
                          :quote="0"
                          :imgName="'image_url'"
                          :index="index"
                        ></choose-photo>                
                        <span class="memo">{{getMemo(config['style_type'], index)}}</span>
                    </el-col>
                    <el-col class="col-right">
                        <el-input placeholder="请输入商品ID" clearable size="small" v-model="config[field.key][index]['link_name']"></el-input>
                        <el-button v-if="config[field.key][index]['link_name']" size="mini" class="clear-link"
                                   @click="clearLink(index)" style="margin-left: 0px;">清除商品ID
                        </el-button>
                    </el-col>
                    <i class="el-icon-circle-close-outline" v-if="config['style_type'] === 9"
                       @click="removeImageItem(index)"></i>
                </el-row>
            </draggable>
            <el-button size="mini" v-if="config['style_type'] === 9" @click="addImageItem()">添加链接</el-button>
        </el-form-item>
        <!-- 店铺地址对话框 -->
        <el-dialog title="请选择链接" :visible.sync="dialog.visible" @close='closeDialog'>
            <helper @select="select" @close='closeDialog'></helper>
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
    .sortable-ghost {
        background-color: #f7f8f9;
    }

    .radio-img {
        width: 80px;
    }

    .image-item {
        border: 1px solid #E3E7EE;
        background-color: #F9F9F9;
        border-radius: 4px;
        padding: 16px;
        position: relative;
        margin-bottom: 20px;
        .col-left {
            flex: 0 0 150px;
        }
        .col-right {
            flex: 1;
            .link-name {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 100px;
                padding-right: 10px;
            }
        }
        .el-icon-circle-close-outline {
            font-size: 18px;
            position: absolute;
            top: -9px;
            right: -9px;
            background: #FFF;
            color: #999;
            cursor: pointer;
        }
    }

    .memo {
        display: inline-block;
        font-size: 13px;
        color: #C5C5C5;
        vertical-align: bottom;
    }

    .radio-group {
        display: flex;
        flex-wrap: wrap;
        .radio-item {
            width: 110px;
            margin-bottom: 10px;
            img {
                border: 1px solid #E3E7EE;
            }
            [aria-checked=true] img {
                border: 1px solid #4A8EF7;
            }
            span {
                display: block;
                font-size: 13px;
                padding: 10px 0 10px 0;
                margin: 0 8px 0 24px;
                text-align: center;
            }
            span.selected {
                color: #4A8EF7;
            }
        }
    }
</style>

<script>

  import ChoosePhoto from "./choose-photo.vue";
  import draggable from 'vuedraggable'

  export default {
    name: 'tms-type-img-set',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      source: {
        type: String,
      }
      // config: {
      //   type: Object,
      //   default() {
      //     return {}
      //   }
      // }
    },
    computed: {
      // 右侧组件数据初始化
      config() {
        console.log(this.source)
        if (this.source === 'tmsPageConfig') {
        return this.$store.state.tms.pageData
        }
        if (this.source === 'tmsModuleConfig') {
        return this.$store.state.tms.config;
        }
        return this.$store.state.tms.customConfig;
      }
    },
    data() {
      return {
        dialog: {
          visible: false
        },
        currentRadioIndex: 1,
        radioList: [{
          "url": "https://img.mockuai.com/tms/2018/1/9/upload_6c63e1df61d25051b04b3ff9581e6798.png",
          "value": 1,
          "text": "单列"
        }, {
          "url": "https://img.mockuai.com/tms/2018/1/9/upload_66bd74cc1c491d8ba81f99bbee173d98.png",
          "value": 2,
          "text": "双列"
        }, {
          "url": "https://img.mockuai.com/tms/2018/1/9/upload_76d6fdf0c86d8b50bb8f9de2d21c2974.png",
          "value": 3,
          "text": "左一右二"
        }, {
          "url": "https://img.mockuai.com/tms/2018/1/9/upload_d3794f30f484f28362f5a41a13c08ee6.png",
          "value": 4,
          "text": "左二右一"
        }, {
          "url": "https://img.mockuai.com/tms/2018/1/9/upload_7c7b1ca0f8aa6e6655745971848e3547.png",
          "value": 5,
          "text": "三列"
        }, {
          "url": "https://img.mockuai.com/tms/2020/4/21/upload_ee81096b5729d4a33c3c7b626907bb07.png",
          "value": 6,
          "text": "四列"
        }],
        currentIndex: 0,
        radio: 1
      }
    },

    components: {
      draggable,
      ChoosePhoto
    },

    mounted() {
      if (!this.config[this.field.key].length) {
        this.config[this.field.key].push({})
      }
    },

    methods: {
      clearLink(index) {
        delete this.config[this.field.key][index].link_name;
        delete this.config[this.field.key][index].link_data;
        delete this.config[this.field.key][index].link_type;
        let temp = this.config[this.field.key][index];
        this.config[this.field.key].splice(index, 1, temp);
      },
      addImageItem() {
        if (this.config[this.field.key].length < 10) {
          this.config[this.field.key].push({})
        } else {
          this.$message.error('最多上传10张图片');
        }
      },
      removeImageItem(index) {
        this.config[this.field.key].splice(index, 1);
      },
      openDialog(index) {
        this.currentIndex = index;
        this.dialog.visible = true;
      },
      closeDialog() {
        this.dialog.visible = false;
      },
      change(val) {
        this.currentRadioIndex = val;
        this.config[this.field.key] = [];
        let length = 1;
        switch (val) {
          case 2:
            length = 2;
            break;
          case 3:
          case 4:
          case 5:
            length = 3;
            break;
          case 6:
            length = 4;
            break;
          case 7:
          case 8:
            length = 5;
            break;
          case 9:
            length = 4;
            break;
        }
        for (let i = 0; i < length; i++) {
          let item = {};
          item.memo = this.getMemo(val, i);
          this.config[this.field.key].push(item)
        }
      },
      getMemo(val, i) {
        let memo = '';
        switch (val) {
          case 1:
            memo = '建议尺寸：750px*184px';
            break;
          case 2:
            memo = '建议尺寸：375px*304px';
            break;
          case 3:
            if (i === 0) {
              memo = '建议尺寸：316px*396px';
            } else {
              memo = '建议尺寸：432px*198px';
            }
            break;
          case 4:
            if (i === 2) {
              memo = '建议尺寸：316px*396px';
            } else {
              memo = '建议尺寸：432px*198px';
            }
            break;
          case 5:
            memo = '建议尺寸：250px*294px';
            break;
          case 6:
            memo = '建议尺寸：375px*204px';
            break;
          case 7:
            if (i === 0) {
              memo = '建议尺寸：316px*396px';
            } else {
              memo = '建议尺寸：218px*198px';
            }
            break;
          case 8:
            if (i === 4) {
              memo = '建议尺寸：316px*396px';
            } else {
              memo = '建议尺寸：218px*198px';
            }
            break;
          case 9:
            memo = '建议尺寸：240px*240px';
            break;
        }
        return memo;
      },
      select(link, linkName, linkType) {
        this.config[this.field.key][this.currentIndex].link_name = linkName;
        this.config[this.field.key][this.currentIndex].link_data = link;
        this.config[this.field.key][this.currentIndex].link_type = linkType;

        this.dialog.visible = false;
      }
    }
  }

</script>
